// Проверка на локальный или тестовый/дев контур
export const isDevHost = (): boolean => {
    return /localhost|-(dev|test)\./i.test(window.location.hostname);
};